export const getCompareLink = compareVehicles => {
	let compareBaseUrl = '';
	if (window.DDC.InvData && window.DDC.InvData.COMPARE_PAGE) {
		compareBaseUrl = window.DDC.InvData.COMPARE_PAGE;
	}
	return compareBaseUrl
		? compareBaseUrl.concat(
				`?itemIds=${encodeURIComponent(compareVehicles.join())}`
		  )
		: '';
};
